<div *ngIf="page === 'view' then edit_install else new_install"></div>
<ng-template #edit_install><h2 i18n="@@modifyInstall">Modify install</h2></ng-template>
<ng-template #new_install><h2 i18n="@@newInstall">New install</h2></ng-template>
<form [formGroup]="installInfoForm">
  <!-- Numéro de license -->
  <label i18n="@@licenseKey">License key</label>
  <div class="input-group mb-3">
    <span class="input-group-addon"><span class="fa fa-certificate" style="margin: 2px"></span></span>
    <div *ngIf="page === 'view'; then idInstall_field_view else idInstall_field_list"></div>
    <ng-template #idInstall_field_view><input [ngModel]="install.idInstall" type="text" style="text-transform:uppercase" class="form-control" formControlName="idInstall" i18n-placeholder placeholder="License number" disabled/></ng-template>
    <ng-template #idInstall_field_list><input type="text" style="text-transform:uppercase" class="form-control" placeholder="License number" disabled/></ng-template>
  </div>
  <!-- Nom du client -->
  <label i18n="@@clientName">Client name</label>
  <div class="input-group mb-3">
    <span class="input-group-addon"><span class="fa fa-id-badge" style="margin: 2px"></span></span>
    <div *ngIf="page === 'view'; then name_field_view else name_field_list"></div>
    <ng-template #name_field_view><input [ngModel]="install.nom" type="text" style="text-transform:uppercase" class="form-control" formControlName="licenseName" i18n-placeholder placeholder="Name" maxlength="52" required /></ng-template>
    <ng-template #name_field_list><input type="text" style="text-transform:uppercase" class="form-control" formControlName="licenseName" i18n-placeholder placeholder="Name" maxlength="52" required /></ng-template>
  </div>
  <!-- Numéro de client -->
  <label i18n="@@clientNumber">Client number</label>
  <div class="input-group mb-3">
    <span class="input-group-addon">@</span>
    <div *ngIf="page === 'view'; then numero_client_field_view else numero_client_field_list"></div>
    <ng-template #numero_client_field_view><input [ngModel]="install.numeroClient" type="text" style="text-transform:uppercase" class="form-control" formControlName="clientNumber" i18n-placeholder placeholder="Client number" maxlength="12" required /></ng-template>
    <ng-template #numero_client_field_list><input type="text" style="text-transform:uppercase" class="form-control" formControlName="clientNumber" i18n-placeholder placeholder="Client number" maxlength="12" required /></ng-template>
  </div>
  <!-- Durée de location -->
  <label i18n="@@rentDuration">Rent duration</label>
  <div class="input-group mb-3">
    <span class="input-group-addon"><span class="fa fa-calendar" style="margin: 1px"></span></span>
    <input type="text" style="text-transform:uppercase" class="form-control" i18n-placeholder placeholder="Rent duration" disabled/>
  </div>
</form>

<label i18n="@@parameters">Parameters</label>

<div class="box box-capa">
  <div class="box-header with-border">
    <h3 class="box-title" i18n="@@parameters">Parameters</h3>

    <div class="box-tools pull-right">
      <button type="button" class="btn btn-box-tool" (click)="paramsOpen = !paramsOpen">
        <em [ngClass]="paramsOpen ? 'fa fa-plus' : 'fa fa-minus'"></em>
      </button>
    </div>
    <!-- /.box-tools -->
  </div>
  <!-- /.box-header -->
  <div class="box-body" [hidden]="paramsOpen">
    <table class="table table-bordered" style="color: black" id="parametersTable" aria-describedby="Licenses parameters table">
      <thead>
      <tr>
        <th id="parameterstable-parameters" i18n="@@parameters">Parameters</th>
        <th id="parameterstable-values" i18n="@@value">Values</th>
        <th id="parameterstable-global" i18n="@@global">Global</th>
      </tr>
      </thead>
      <tbody *ngIf="allParameters.length > 0 else loading">
      <tr *ngFor="let param of allParameters; let id = index">
        <td style="word-break: break-all;">{{ param.nomParam }}</td>
        <td>
          <span contenteditable="true" (blur)="updateList(id, 'valeurParam', $event)" style="word-break: break-all;">{{ param.valeurParam }}</span>
        </td>
        <td>
          <div *ngIf="param.estGlobal"><input type="checkbox" disabled checked></div>
          <div *ngIf="!param.estGlobal"><input type="checkbox" disabled></div>
        </td>
      </tr>
      </tbody>
    </table>

    <ng-template #loading>
      <tbody align="center">
      <tr>
        <td colspan="3">
          <em class="fa fa-spin fa-refresh"></em>&nbsp; <span i18n="@@InProgress">In progress</span>
        </td>
      </tr>
      </tbody>
    </ng-template>

  </div>
</div>
<div class="row">
  <div class="col-sm-6 col-xs-6">
    <div *ngIf="page === 'view'; then save_changes else create_install"></div>
    <ng-template #create_install><button class="btn btn-primary btn-block btn-lg" type="submit" (click)="onSubmitInstallInfoForm(installInfoForm.value)" [disabled]="!installInfoForm.valid" i18n="@@validate">Validate</button></ng-template>
    <ng-template #save_changes><button class="btn btn-primary btn-block btn-lg" type="submit" (click)="onUpdateInstallParameters(installInfoForm.value)" [disabled]="!installInfoForm.valid" i18n="@@save">Save</button></ng-template>
  </div>
  <div class="col-sm-6 col-xs-6">
    <button class="btn btn-default btn-block btn-lg" data-toggle="control-sidebar" i18n="@@cancel">Cancel</button>
  </div>
</div>
<div *ngIf="success == true" style="margin-top: 16px" class="alert alert-success alert-dismissible">
  <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
  <h4 i18n="@@success">SUCCESS</h4>
  <div *ngIf="page === 'view' then save else create"></div>
  <ng-template #save><p i18n="@@licenseUpdateSuccessful">The license has been successfully updated !</p></ng-template>
  <ng-template #create><p i18n="@@licenseCreateSuccessful">The license has been successfully created !</p></ng-template>
</div>
